/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { Modal } from 'react-bootstrap';
import "../../styles/time_table_management.css";
import applicationstagesLabels from '../labels/applicationstages_en.json'
import _ from "lodash/fp";
import { getExamCenterListAPI } from "../../../timetablemanagement/actions/timetableManagementAction";
import { toUTCDate } from "../../../helpers/Datetime";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import { getInterviewPtLetterDropdownValuesAPI, downloadAttendanceMusterListFileAPI, downloadUploadedInterviewPtLetterFile, getApplicationDetailsAPI, getAllNameOfIndexingBodies, getAllPublicationArticleTypes } from "../actions/applicationStagesAction";
import candidateLabels from "../../../candidatedatamanagement/labels/candidatedatamanagement_en.json";
import ProfileApplicationReport from './ProfileApplicationReport';
import SummarySheetReport from './SummarySheetReport';

const AttendanceMusterReportModal = (props) => {
    const dispatch = useDispatch();
    const printRef = useRef();
    const printSummarySheetRef = useRef();
    const { register, control, errors } = useForm({
        mode: "onChange",
    });
    let [examCenter, setExamCenter] = useState("");
    let [interviewCommittee, setInterviewCommittee] = useState('');
    let [interviewDate, setInterviewDate] = useState('');
    let [interviewSession, setInterviewSession] = useState('');
    let [venueName, setVenueName] = useState('');
    let [printProfile, setPrintProfile] = useState(false);
    let [printSummarySheet, setPrintSummarySheet] = useState(false);

    const { getExamCenterList } = useSelector((state) => state.timeTableManagementReducer, shallowEqual);
    const { getInterviewPtLetterDropdownValues, getCandidateList } = useSelector((state) => state.applicationManagementReducer, shallowEqual);

    useEffect(() => {
        props && props.advtId && dispatch(getExamCenterListAPI(props.advtId));
        props && props.advtId && dispatch(getInterviewPtLetterDropdownValuesAPI(props.advtId, props.reportType, props.interviewPtLetterReportPostId))
        props && props.advtId && dispatch(getAllNameOfIndexingBodies());
        props && props.advtId && dispatch(getAllPublicationArticleTypes());
    }, []);

    const handleDownloadInterviewReportClick = () => {
        let examCenterId = examCenter ? examCenter : '';
        let interviewCommitteeId = interviewCommittee ? interviewCommittee : '';
        let interviewReportDate = interviewDate ? interviewDate : '';
        let interviewSessionId = interviewSession ? interviewSession : '';

        dispatch(downloadAttendanceMusterListFileAPI(props.advtId, props.interviewPtLetterReportPostId, props.reportType, examCenterId, interviewCommitteeId, interviewReportDate, interviewSessionId, venueName, props.interviewPtLetterReportName));
        setExamCenter('');
        setInterviewCommittee('');
        setInterviewDate('');
        setInterviewSession('');
        setVenueName('');
    };

    const cancelModal = () => {
        props.setOpenAttendanceMusterReportModal(false);
        props.setInterviewPtLetterReportPostId('');
        props.setInterviewPtLetterReportName('');
        props.setReportType('');
        setExamCenter('');
        setInterviewCommittee('');
        setInterviewDate('');
        setInterviewSession('');
        setVenueName('');
        getCandidateList.length = 0;
    }

    const handleViewApplicationProfileReportClick = () => {
        let examCenterId = examCenter ? examCenter : '';
        let interviewCommitteeId = interviewCommittee ? interviewCommittee : '';
        let interviewReportDate = interviewDate ? dayjs(interviewDate).format(applicationstagesLabels.DATE_FORMAT_LABEL) : '';
        let interviewSessionId = interviewSession ? interviewSession : '';
        dispatch(downloadUploadedInterviewPtLetterFile(props.advtId, props.reportType, props.interviewPtLetterReportPostId, examCenterId, interviewReportDate, interviewSessionId, '', interviewCommitteeId, venueName, props.interviewPtLetterReportName));
        // setExamCenter('');
        // setInterviewCommittee('');
        // setInterviewDate('');
        // setInterviewSession('');
        // setVenueName('');
    };

    const viewCandidateDetails = (ele) => {
        let appId = ele && ele.applicationId;
        dispatch(getApplicationDetailsAPI(appId, props.interviewPtLetterReportPostId));
        if (props.interviewPtLetterReportName === 'SUMMARY SHEET') {
            setPrintSummarySheet(true);
        } else {
            setPrintProfile(true)
        }
    };

    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const printContainer = document.createElement('div');
        printContainer.innerHTML = printContents;
        document.body.innerHTML = '';
        document.body.appendChild(printContainer);
        window.print();
        window.location.reload();
    };

    const handleCancel = () => {
        setPrintProfile(false);
        setPrintSummarySheet(false);
    };

    const handlePrintSummarySheet = () => {
        const printContents = printSummarySheetRef.current.innerHTML;
        const printContainer = document.createElement('div');
        printContainer.innerHTML = printContents;
        document.body.innerHTML = '';
        document.body.appendChild(printContainer);
        window.print();
        window.location.reload();
    };

    const handleCancelSummarySheetModal = () => {
        setPrintSummarySheet(false);
    };

    return (
        <div>
            <Modal size="xl" show={props.openAttendanceMusterReportModal} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static'>
                <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title className=" logout_title">
                        {(props.interviewPtLetterReportName === 'ATTENDANCE MUSTER') ? applicationstagesLabels.ATTENDANCE_MUSTER_REPORT : (props.interviewPtLetterReportName === 'TOKEN MUSTER') ? applicationstagesLabels.TOKEN_MUSTER_REPORT : (props.interviewPtLetterReportName === 'TOKEN MAPPING REPORT') ? applicationstagesLabels.TOKEN_MAPPING_MUSTER_REPORT : (props.interviewPtLetterReportName === 'VERIFICATION MUSTER') ? applicationstagesLabels.VERIFICATION_MUSTER : (props.interviewPtLetterReportName === 'Application Recommendation') ? applicationstagesLabels.APPLICATION_RECOMMENDATION : (props.interviewPtLetterReportName === 'Profile Details') ? applicationstagesLabels.PROFILE_DETAILS : (props.interviewPtLetterReportName === 'SUMMARY SHEET') ? applicationstagesLabels.SUMMARY_SHEET : ''}
                    </Modal.Title>
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">
                                {applicationstagesLabels.INTERVIEW_CENTER}&nbsp;
                                <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                                <select
                                    className="form-select bg-color"
                                    name="examCenter"
                                    value={examCenter}
                                    defaultValue={examCenter}
                                    ref={register({ required: true })}
                                    onInput={(e) => {
                                        setExamCenter(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {applicationstagesLabels.COMBO_SELECT}
                                    </option>
                                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.examCenterList &&
                                        getInterviewPtLetterDropdownValues.examCenterList.length > 0 &&
                                        getInterviewPtLetterDropdownValues.examCenterList.map((element, index) => (
                                            <option key={index} value={element.id}>
                                                {element.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            {_.get("examCenter.type", errors) === "required" && (
                                <p className="errorText float-start mt-n4">
                                    {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                </p>
                            )}
                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">
                                {applicationstagesLabels.scheduleListHeaderContent[5]}&nbsp;
                                <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                                <select
                                    className="form-select bg-color"
                                    name="venueName"
                                    value={venueName}
                                    ref={register({ required: true })}
                                    onInput={(e) => {
                                        setVenueName(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {applicationstagesLabels.COMBO_SELECT}
                                    </option>
                                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.venueList &&
                                        getInterviewPtLetterDropdownValues.venueList.length > 0 &&
                                        getInterviewPtLetterDropdownValues.venueList.map((element, index) => (
                                            <option key={index} value={element.label}>
                                                {element.label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            {_.get("venueName.type", errors) === "required" && (
                                <p className="errorText float-start mt-n4">
                                    {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                </p>
                            )}
                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">
                                {applicationstagesLabels.INTERVIEW_COMMITTEE}&nbsp;
                                <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                                <select
                                    className="form-select bg-color"
                                    name="interviewCommittee"
                                    value={interviewCommittee}
                                    ref={register({ required: true })}
                                    onInput={(e) => {
                                        setInterviewCommittee(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {applicationstagesLabels.COMBO_SELECT}
                                    </option>
                                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.committeeList &&
                                        getInterviewPtLetterDropdownValues.committeeList.length > 0 &&
                                        getInterviewPtLetterDropdownValues.committeeList.map((element, index) => (
                                            <option key={index} value={element.id}>
                                                {element.label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            {_.get("interviewCommittee.type", errors) === "required" && (
                                <p className="errorText float-start mt-n4">
                                    {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                </p>
                            )}
                        </div>
                        <div className="col-md-4">
                            <label className="fw-bold">{applicationstagesLabels.INTERVIEW_DATE}<span className="errorText">*</span></label>
                            <Controller
                                name="interviewDate"
                                defaultValue={
                                    interviewDate ? dayjs(interviewDate).toDate() : ""
                                }
                                rules={{ required: true }}
                                control={control}
                                render={({ onChange, value }) => (
                                    <div className="date-picker-container">
                                        <DatePicker
                                            selected={
                                                interviewDate ? dayjs(interviewDate).toDate() : ""
                                            }
                                            onChange={(e) => {
                                                setInterviewDate(toUTCDate(e));
                                                onChange(toUTCDate(e));
                                            }}
                                            showMonthDropdown
                                            showYearDropdown
                                            placeholderText={applicationstagesLabels.DATE_FORMAT}
                                            dateFormat={applicationstagesLabels.SMALL_SIZE_DATE_FORMAT}
                                            className="form-control bg-color ps-2"
                                            showIcon
                                            icon={
                                                <img src="/icons/calender.png" className="date-picker-icon"></img>
                                            }
                                        />
                                    </div>
                                )}
                            />
                            {_.get("interviewDate.type", errors) === "required" && (
                                <p className="errorText">
                                    {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                </p>
                            )}
                        </div>
                        <div className="col-md-4">
                            <label className="fw-bold">
                                {applicationstagesLabels.INTERVIEW_SESSION}&nbsp;
                                <span className="redColor">*</span>
                            </label>
                            <div className="input-group bg-color">
                                <select
                                    className="form-select bg-color"
                                    name="interviewSession"
                                    value={interviewSession}
                                    ref={register({ required: true })}
                                    onInput={(e) => {
                                        setInterviewSession(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {applicationstagesLabels.COMBO_SELECT}
                                    </option>
                                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.sessionList &&
                                        getInterviewPtLetterDropdownValues.sessionList.length > 0 &&
                                        getInterviewPtLetterDropdownValues.sessionList.map((element, index) => (
                                            <option key={index} value={element.id}>
                                                {element.label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            {_.get("interviewSession.type", errors) === "required" && (
                                <p className="errorText float-start mt-n4">
                                    {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                </p>
                            )}
                        </div>
                        {((props.interviewPtLetterReportName === 'Profile Details') || (props.interviewPtLetterReportName === 'Application Recommendation') || (props.interviewPtLetterReportName === 'SUMMARY SHEET')) ?
                            <div className="col-md-4">
                                <button
                                    className="btn btn-sm btn-primary cursor-pointer mt27"
                                    onClick={() =>
                                        handleViewApplicationProfileReportClick()
                                    }
                                    disabled={(!examCenter) || (!interviewCommittee) || (!interviewDate) || (!interviewSession) || (!venueName)}
                                >
                                    {applicationstagesLabels.VIEW_REPORT}
                                </button>
                            </div>
                            :
                            <div className="col-md-4">
                                <button
                                    className="btn btn-sm btn-primary cursor-pointer mt27"
                                    onClick={() =>
                                        handleDownloadInterviewReportClick()
                                    }
                                    disabled={(!examCenter) || (!interviewCommittee) || (!interviewDate) || (!interviewSession) || (!venueName)}
                                >
                                    {applicationstagesLabels.DOWNLOAD_OBJECTION_REPORT}
                                </button>
                            </div>
                        }
                    </div>
                    {((getCandidateList) && (getCandidateList.length > 0)) ?
                        <div className="box-one">
                            <div className="border border-light text-center w-100 p-3" >
                                <table className="table">
                                    <thead >
                                        <tr>{candidateLabels.applicationProfileReportTableHeader.map((ele, i) => <th scope="col" key={i} className='theadBgColor'>{ele}</th>)}</tr>
                                    </thead>
                                    <tbody>
                                        {getCandidateList && getCandidateList.map((ele, i) => {
                                            if (ele) {
                                                return (
                                                    <tr key={i}>
                                                        <th>{ele && ele.profileTransactionID && ele.profileTransactionID}</th>
                                                        <th>{ele && ele.candidateName && ele.candidateName}</th>
                                                        <th>
                                                            <button className="btn btn-outline-primary  custom_button  btn-sm cursor-pointer" type="button" onClick={(e) => { viewCandidateDetails(ele) }}>{candidateLabels.VIEW}</button>
                                                        </th>
                                                    </tr>
                                                )
                                            }
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div> :
                        <div>
                            {
                                (((props.interviewPtLetterReportName === 'Profile Details') || (props.interviewPtLetterReportName === 'Application Recommendation'))) ? <p className="text-center">{candidateLabels.NO_DATA_TO_DISPLAY}</p> : ''
                            }
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal}>{applicationstagesLabels.CANCEL}</button>
                </Modal.Footer>
            </Modal>

            <Modal size="xl" show={printProfile} onHide={handleCancel} backdrop='static'>
                <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={handleCancel}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div ref={printRef}>
                        <ProfileApplicationReport setPrintProfile={setPrintProfile} printProfile={printProfile} interviewPtLetterReportName={props.interviewPtLetterReportName} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="  " onClick={handlePrint} >{candidateLabels.PRINT}</button>
                    <button type="button" className="btn btn-secondary" onClick={handleCancel} >{applicationstagesLabels.CANCEL}</button>
                </Modal.Footer>
            </Modal>

            <Modal size="xl" show={printSummarySheet} onHide={handleCancelSummarySheetModal} backdrop='static'>
                <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={handleCancelSummarySheetModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div ref={printSummarySheetRef}>
                        <SummarySheetReport setPrintSummarySheet={setPrintSummarySheet} printSummarySheet={printSummarySheet} interviewPtLetterReportName={props.interviewPtLetterReportName} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className=" btn btn-primary custom_button   " onClick={handlePrintSummarySheet} >{candidateLabels.PRINT}</button>
                    <button type="button" className="btn btn-secondary" onClick={handleCancelSummarySheetModal} >{applicationstagesLabels.CANCEL}</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AttendanceMusterReportModal;